import PropTypes from 'prop-types';
import { useDictionary } from '../../../../../../../../utilities/hooks/UseDictionary';
import PoiExperienceItem from './PoiExperienceItem';
import {useHistory} from 'react-router-dom'
import { NavigatorPaths } from '../../../../../../../../assets/dictionaries/NavigatorPaths';

const PoiExperiences = ({details}) => {
    const dictionary  = useDictionary();
    const history = useHistory();

    const onExperienceClicked = (experienceItem) => {
        history.push(`/${NavigatorPaths.admin_experiences.path}/${experienceItem.id}`);
    }
    
    return (
        <div className="detail-tab-container thin-scrollbar fade-on-load">
            <div
				className="participant-row-container"
				style={{ justifyContent: 'space-between', marginBottom: '16px' }}
			>
				<h3>
					{dictionary.poi_experiences}
				</h3>
			</div>
            {
                (details?.experiences && details.experiences.length > 0) ? (
                    <table style={{ marginLeft: -8, borderCollapse: "collapse" }} className='provider-customer-booking-listing'>
                        <tbody>
                            {details.experiences.map(item => (
                                <PoiExperienceItem
                                    key={item.id}
                                    onItemCLicked={() => onExperienceClicked(item)}
                                    experience={item}
                                />
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div className="empty-provider-customers-list-placeholder d-flex-center">
                        <div className="empty-provider-customers-image empty-provider-customers-details-image"/>
                        <h3
                            data-testid="no-bookings-yet-header"
                            className='empty-provider-customers-title'
                        >
                            {dictionary.no_experiences_yet}
                        </h3>
                        <div className="text empty-provider-customers-message">
                            {dictionary.all_experiences_will_be_listed}
                        </div>
                    </div>
                )
            }
        </div>
    )
}

PoiExperiences.propTypes = {
    details: PropTypes.object
};

export default PoiExperiences;